import React from "react";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  container: {
    position: "absolute",
    margin: "40px 0px 0px 5px",
    backgroundColor: theme.ModalBGColor,
    top: 0,
    zIndex: 500,
  },
  routeDetails: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    padding: "5px 10px",
  },
  logoContainer: {
    position: "absolute",
    zIndex: 500,
    top: 4,
    right:10,
    float: "right",
    padding: "5px",
    height: "20px",
  },
});

const RouteReportHeader = ({ classes, routesData }) => {
  return (
    <div className="onlyPrint">
     <img
        src="./../../../../images/RouteMax_Logo_Print.svg"
        className={classes.logoContainer}
      />
      {routesData?.length > 0 ? (
        <div className={classes.container}>
          {routesData.map((route) => (
            <div
              className={classes.routeDetails}
              style={{ color: route.color }}
              key={route.routeName}
            >
              Route {route.routeName} : {route.routeStops.length} stops
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(RouteReportHeader);
